import _objectSpread from "/var/lib/jenkins/workspace/event-xsj-260120-vue/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/esnext.uint8-array.set-from-base64.js";
import "core-js/modules/esnext.uint8-array.set-from-hex.js";
import "core-js/modules/esnext.uint8-array.to-base64.js";
import "core-js/modules/esnext.uint8-array.to-hex.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
// import User from "@/api/user.js";
/**
 * 地址栏query 处理
 * @param href `string`  需要qs的url
 * @param ignoreHash `boolean` 是否忽略hash后面的参数
 * @default (window.location.href, false)
 * @returns
 */
import Vue from "vue";
import Cookie from "js-cookie";
import i18nwordConfig, { LANG_MAPS } from "@/lib/i18nwordConfig";
import request from "@/utils/request";
// import { isAppEnv , appDownload } from "@/components/basic/parts/kuroJsbridge/index";
// import { useInfoStore } from "@/stores/info";
// const { getOssSign, uploadOss } = useInfoStore();
import { v4 as uuidv4 } from "uuid";
export const qs = (href = window.location.href, ignoreHash = false) => {
  const result = {};
  let param = null;
  const reg = /[?&](.*?)=([^&#]*)/g;
  if (ignoreHash) {
    href = href.replace(/#.*?$/, "");
  }
  param = reg.exec(href);
  while (param) {
    // 上面已经decode过，不需要重复decode，过度decode会导致其它问题
    // result[param[1]] = param[2];
    try {
      result[param[1]] = decodeURIComponent(param[2]);
    } catch (e) {
      try {
        result[param[1]] = unescape(param[2]);
      } catch (escapeErr) {
        // eslint-disable-next-line prefer-destructuring
        result[param[1]] = param[2];
      }
      // result[param[1]] = `Decode Error: ${param[2]}`;
    }
    param = reg.exec(href);
  }
  return result;
};
export const QS = qs();
const getLocation = url => {
  const a = document.createElement("a");
  a.href = url;
  return a;
};
const getOriginByTag = tag => {
  let origin = tag.origin;
  if (!origin) {
    origin = tag.protocol + "//" + tag.hostname + (tag.port ? ":" + tag.port : "") + "/";
  }
  return origin;
};
export function addParamsToUrl(url, params, isPre = false) {
  const u = getLocation(url);
  const {
    href,
    pathname,
    hash
  } = u;
  const mergeParams = isPre ? _objectSpread(_objectSpread({}, params), qs(href, true)) : _objectSpread(_objectSpread({}, qs(href, true)), params);
  const str = Object.keys(mergeParams).reduce((ta, va) => mergeParams[va] ? ta.concat(`${!ta ? "?" : "&"}${va}=${mergeParams[va]}`) : ta, "");
  const origin = getOriginByTag(u);
  return `${origin}${pathname}${str}${hash}`;
}
function getBrowserInfo() {
  let deviceType;
  const browser = {
    versions: function () {
      const u = navigator.userAgent;
      // const app = navigator.appVersion;
      return {
        // 移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1,
        // IE内核
        presto: u.indexOf("Presto") > -1,
        // opera内核
        webKit: u.indexOf("AppleWebKit") > -1,
        // 苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1,
        // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
        // android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1,
        // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1,
        // 是否iPad
        webApp: u.indexOf("Safari") === -1 // 是否web应该程序，没有头部与底部
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  if (browser.versions.mobile || browser.versions.ios || browser.versions.android || browser.versions.iPhone || browser.versions.iPad) {
    deviceType = "mobile";
  } else {
    deviceType = "pc";
  }
  return {
    deviceType,
    language: browser.language
  };
}
export const track = async ({
  category,
  action,
  label,
  value,
  extra
}) => {
  const host = process.env.NODE_ENV !== "production" ? 'https://api-test.weekver.fun' : 'https://api.weekver.fun';
  return request.post(`${host}/report/report`, {
    event_id: "m20260122klh7g4tvbd",
    company_id: 3,
    project_id: "xishanju",
    sdk_version: 1,
    source_type: 1,
    timestamp: Math.floor(Date.now() / 1000),
    page_info: JSON.stringify({
      app_id: 1,
      page_id: 1,
      page_url: window.document.location.href,
      referer: window.document.referrer
    }),
    event_info: JSON.stringify({
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
      extra_info: extra
    }),
    user_info: JSON.stringify({
      lang: getRealLang(),
      user_agent: window.navigator.userAgent
    })
  }, {
    ignoreError: true
  });
};
let langList = null;
export const initLang = async () => {
  const lang = getRealLang();
  Vue.prototype.$lang = lang;
  if (!langList) {
    try {
      const {
        data
      } = await request.post(process.env.VUE_APP_I18N_URL, {
        event_id: "m20260122klh7g4tvbd",
        company_id: 3,
        module: "1",
        lang: lang
      });
      langList = data;
    } catch (_unused) {
      langList = {};
    }
  }
  Vue.prototype.$getI18nWord = function (key) {
    try {
      const rootElement = document.documentElement;
      rootElement.setAttribute("lang", lang);
      return _objectSpread(_objectSpread({}, i18nwordConfig[lang]), langList)[key];
    } catch (error) {
      return "";
    }
  };
};
export const getRealLang = () => {
  var _getBrowserInfo$langu;
  if (!IS_SEA) {
    return "zh-cn";
  }
  const qsLang = LANG_MAPS.find(item => item.value.includes(QS.lang));
  const browserLang = LANG_MAPS.find(item => item.value.includes(getBrowserInfo().language));
  const bLang = browserLang ? browserLang.value : "en-us";
  const cookieLang = Cookie.get("mi18nLang");
  let curlang = "";
  if (((_getBrowserInfo$langu = getBrowserInfo().language) === null || _getBrowserInfo$langu === void 0 ? void 0 : _getBrowserInfo$langu.toLowerCase()) === "zh-hk") {
    curlang = "zh-tw";
  }
  const realLang = (qsLang === null || qsLang === void 0 ? void 0 : qsLang.value) || cookieLang || curlang || bLang;
  return LANG_MAPS.find(item => item.value === realLang) ? realLang : "en-us";
};
export function base64ToFile(base64String, fileName) {
  // 分割base64数据，获取MIME类型和实际数据
  const arr = base64String.split(",");
  const mimeMatch = arr[0].match(/:(.*?);/);
  // 如果无法解析MIME类型，默认使用application/octet-stream
  const mimeType = mimeMatch ? mimeMatch[1] : "application/octet-stream";
  // 解码base64数据为二进制字符串
  const bstr = atob(arr[1]);
  let n = bstr.length;
  // 创建Uint8Array数组存储二进制数据
  const u8arr = new Uint8Array(n);
  // 填充二进制数据
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  // 创建并返回File对象
  // 第三个参数是可选的，用于指定文件的最后修改时间
  return new File([u8arr], fileName, {
    type: mimeType
  });
}
// export const getUrlByBase64 = async (url: string) => {
//   const uuid = uuidv4();
//   const fileData = base64ToFile(url, `kl-event-${+new Date()}${uuid}.jpg`);
//   const data = await getOssSign();
//   const key = `${data.dir}/${fileData.name}`;
//   const formData = new FormData();
//   formData.append("success_action_status", "200");
//   formData.append("policy", data.policy);
//   formData.append("x-oss-signature", data.signature);
//   formData.append("x-oss-signature-version", "OSS4-HMAC-SHA256");
//   formData.append("x-oss-credential", data.x_oss_credential);
//   formData.append("x-oss-date", data.x_oss_date);
//   formData.append("key", key); // 文件名 这里用playerId+"/"+时间戳+文件名后缀
//   formData.append("x-oss-security-token", data.security_token);
//   formData.append("file", fileData); // file 必须为最后一个表单域
//   await uploadOss(data.host, formData);
//   return `${data.host}/${key}`;
// };
/**
 * 基于 Base64 字符串下载图片
 * @param {string} base64Data - 完整的 Base64 图片字符串（格式如：data:image/png;base64,...）
 * @param {string} [fileName] - 可选，下载的文件名（不带后缀则自动根据图片类型补充）
 */
export function downloadImageByBase64(base64Data, fileName = "") {
  downloadImage(base64Data);
}
export async function urlToBase64(url) {
  try {
    // 1. 获取资源（返回Blob对象）
    const response = await fetch(url);
    if (!response.ok) throw new Error("资源获取失败");
    const blob = await response.blob();
    // 2. 将Blob转为Base64
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // result是DataURL格式（包含Base64）
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob); // 核心方法：将Blob转为DataURL
    });
  } catch (error) {
    console.error("转换失败：", error);
    return null;
  }
}
/**
 * 预加载字体包
 * @param fonts 字体配置数组
 * @param onAllLoaded 所有字体加载完成的回调函数
 * @param onError 单个字体加载出错的回调函数
 */
export function preloadFonts(fonts, onAllLoaded, onError) {
  // 检查浏览器是否支持FontFace API
  if (!window.FontFace) {
    console.warn("当前浏览器不支持FontFace API，无法预加载字体");
    onAllLoaded === null || onAllLoaded === void 0 || onAllLoaded([]);
    return;
  }
  const loadedFonts = [];
  const totalFonts = fonts.length;
  fonts.forEach(font => {
    const {
      family,
      src
    } = font;
    try {
      // 创建FontFace实例
      const fontFace = new FontFace(family, src);
      // 加载字体
      fontFace.load().then(loadedFace => {
        // 将字体添加到文档中
        document.fonts.add(loadedFace);
        loadedFonts.push(family);
        // 检查是否所有字体都已加载完成
        if (loadedFonts.length === totalFonts) {
          onAllLoaded === null || onAllLoaded === void 0 || onAllLoaded([...loadedFonts]);
        }
      }).catch(error => {
        console.error(`字体 "${family}" 加载失败:`, error);
        onError === null || onError === void 0 || onError(family, error);
      });
    } catch (error) {
      console.error(`创建字体 "${family}" 实例失败:`, error);
      onError === null || onError === void 0 || onError(family, error);
    }
  });
}
export async function downloadImage(imageUrl, fileName = "") {
  // if (isAppEnv()) {
  //   let urls = ''
  //   if (imageUrl.includes('oss')) {
  //     urls = require(`@images/ossimg/${imageUrl.split('MTIzNDU2Mg==/')[1]}`)
  //   }
  //   const url = await urlToBase64(urls || imageUrl) as any;
  //   url && appDownload(url)
  //   return
  // }
  const uuid = uuidv4();
  // 创建一个隐藏的a标签
  const link = document.createElement("a");
  // 处理文件名（默认使用链接中的文件名或随机名称）
  let name = fileName;
  if (!name) {
    // 从URL中提取文件名
    name = `kl-event-${+new Date()}${uuid}.jpg` || "downloaded-image";
  }
  // 设置a标签属性
  link.href = imageUrl;
  // 设置下载文件名（浏览器会自动添加正确的扩展名）
  link.download = name;
  // 将a标签添加到页面并触发点击
  document.body.appendChild(link);
  link.click();
  // 清理：移除a标签
  setTimeout(() => {
    document.body.removeChild(link);
  }, 0);
}
// window.cc = () => {
// const ossImageUrl = "https://20250917.oss-accelerate.aliyuncs.com/MTIzNDU2Mg==/weekver-event-1761133653795f7c65a22-0575-426a-9e91-a7222e36ae72.jpg";
// // 发起跨域请求
// fetch(ossImageUrl, { mode: "cors" }) // 显式指定跨域模式
//   .then(response => {
//     if (response.ok) {
//       console.log("请求成功，无跨域限制（或 CORS 配置正确）");
//     } else {
//       console.log("请求成功但状态异常（非跨域问题）");
//     }
//   })
//   .catch(error => {
//     if (error.message.includes("CORS") || error.name === "TypeError") {
//       console.log("存在跨域限制：", error.message);
//     } else {
//       console.log("其他错误：", error);
//     }
//   });
// }